
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import PromotionalBanner from '@/components/PromotionalBanner';
import EventListMarketingSection from '@/components/EventListMarketingSection';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import Gradient from '@/assets/medihub_gradient_mesh.jpg';

const OrganizerCTA = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="mb-10">
          <EventListMarketingSection />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-12">
          <PromotionalBanner
            title="Hozza ki a legtöbbet eseményeiből!"
            description="Professzionális eszközökkel segítünk, hogy minél több résztvevőt vonzzon és gördülékenyebb legyen az események szervezése."
            benefits={[
              "Szakmákra szabott célzás és értesítések",
              "Automatikus emlékeztetők és visszaigazolások",
              "Résztvevők könnyű kezelése",
              "Statisztikák és jelentések"
            ]}
            ctaText="Regisztrálok szervezőként"
            ctaAction={() => window.location.href = '/register-organizer'}
            size="lg"
          />

          <div className="rounded-xl overflow-hidden shadow-md relative h-full">
            <div className="absolute inset-0 z-0">
              <img
                src={Gradient}
                alt="Más szakmáknak is"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 z-0"></div>
            </div>
            <div className="p-8 relative z-10 h-full flex flex-col text-white">
              <h3 className="text-2xl font-bold mb-4">Nem az egészségügy az Ön területe?</h3>
              <p className="mb-6 text-white/90">
                Rendszerünk más szakmák számára is tökéletes megoldást nyújt eseményeik kezelésére és promotálására.
                Tekintse meg az iparágspecifikus megoldásainkat!
              </p>
              <div className="mt-auto">
                <Link to="/industry-solutions">
                  <Button className="bg-white text-gray-800 hover:bg-white/90">
                    Szakmai megoldások felfedezése
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrganizerCTA;
